/**
 * Module registry bootstrap.
 * This file MUST be imported before the router so that modules are registered
 * before router/routes.ts evaluates buildModuleRoutes(getModules(), ...).
 *
 * ESM evaluation order is deterministic: because main.ts imports this file
 * before importing the router, and there are no circular dependencies,
 * registerModules() runs before routes.ts is evaluated.
 *
 * To add a new module: import it here and append it to the array.
 */
import { registerModules } from "core-fe-lib/components-shadcn/shell/registry";
import { PipelineModule } from "./pipeline/module";
import { createCronModule } from "cron-fe-lib/module";
import { createOutboxModule } from "outbox-fe-lib/module";
import { createSecretModule } from "secret-fe-lib/module";
import { createCreditModule } from "credit-fe-lib/module";
import { LmsModule } from "./lms/module";
import { ArchitectKeyModule } from "./architectkey/module";
import { AIEmployeeModule } from "./aiemployee/module";

export const modules = [
  createCronModule(),
  createOutboxModule(),
  createSecretModule(),
  PipelineModule,
  createCreditModule(),
  LmsModule,
  ArchitectKeyModule,
  AIEmployeeModule,
];

registerModules(modules);
